// extracted by mini-css-extract-plugin
export var light = "Header-module--light--1CT1e";
export var dark = "Header-module--dark--2nOmj";
export var header = "Header-module--header--1Qt4T";